export const idccAutoriseTT = Object.freeze(['1413', '2378'])
export const nafAutoriseTT = '7820Z' as const
export const idccHCR = '1979'
export const idccBudgetBloque: readonly string[] = Object.freeze([])
export const idccAutoroutes = '2583'
export const idccExclusAlerteEspaceFormation = Object.freeze([...idccAutoriseTT, idccAutoroutes])

export const SmicPeriodes = [
  { debut: new Date('2026-01-01'), fin: null, tauxMetropole: 12.02, tauxMayotte: 9.33 },
  { debut: new Date('2024-11-01'), fin: new Date('2025-12-31'), tauxMetropole: 11.88, tauxMayotte: 8.98 },
  { debut: new Date('2024-01-01'), fin: new Date('2024-10-31'), tauxMetropole: 11.65, tauxMayotte: 8.8 },
  { debut: new Date('2023-05-01'), fin: new Date('2023-12-31'), tauxMetropole: 11.52, tauxMayotte: 8.7 },
  { debut: new Date('2023-01-01'), fin: new Date('2023-04-30'), tauxMetropole: 11.27, tauxMayotte: 8.51 },
  { debut: new Date('2022-08-01'), fin: new Date('2022-12-31'), tauxMetropole: 11.07, tauxMayotte: 8.35 },
  { debut: new Date('2022-05-01'), fin: new Date('2022-07-31'), tauxMetropole: 10.85, tauxMayotte: 8.19 },
  { debut: new Date('2022-01-01'), fin: new Date('2022-04-30'), tauxMetropole: 10.57, tauxMayotte: 7.98 },
  { debut: new Date('2021-10-01'), fin: new Date('2021-12-31'), tauxMetropole: 10.48, tauxMayotte: 7.91 },
  { debut: new Date('2021-01-01'), fin: new Date('2021-09-30'), tauxMetropole: 10.25, tauxMayotte: 7.74 },
  { debut: new Date('2020-01-01'), fin: new Date('2021-12-31'), tauxMetropole: 10.15, tauxMayotte: 7.66 },
]
